import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useState } from "react";
import MDInput from "../../components/MDInput";
import { createPaymentCall, getAccountByNumberCall, getPaymentReceiptData } from "../../api/api";
import DefaultInfoCard from "../../examples/Cards/InfoCards/DefaultInfoCard";
import formatCurrency from "../../helpers/formatCurrency";
import MDButton from "../../components/MDButton";
import MobileNavbar from "../../examples/Navbars/MobileNavbar";
import { paymentPrint } from "../../helpers/print/payment";

export default function Payments() {
  const [state, setState] = useState({
    accountNo: "",
    account: null,
    noResult: false,
    confirmed: false,
    paymentAmount: "",
    reference: "",
    submitted: false,
  });

  const getAccount = async () => {
    if (state.accountNo) {
      const account = await getAccountByNumberCall(state.accountNo);
      setState({
        ...state,
        accountNo: account ? "" : state.accountNo,
        account: account,
        noResult: account == null,
        confirmed: false,
        paymentAmount: "",
        reference: "",
        submitted: false,
      });
    } else {
      global.showAlert(
        "Please add account number.",
        "Account number is required to get the account details",
        "warning"
      );
    }
  };

  const AccountBalance = ({ balance }) => {
    return (
      <Grid container justifyContent={"center"}>
        <Grid item>
          <MDTypography>{"Account Balance "}</MDTypography>{" "}
        </Grid>
        <Grid item ml={2}>
          <MDTypography color={balance >= 0 ? "success" : "error"}>
            {formatCurrency(balance)}
          </MDTypography>
        </Grid>
      </Grid>
    );
  };

  const confirm = () => {
    setState({ ...state, confirmed: true });
  };

  const goBack = () => {
    setState({
      ...state,
      accountNo: "",
      account: null,
      noResult: false,
      confirmed: false,
      paymentAmount: "",
      reference: "",
      submitted: false,
    });
  };

  const pay = () => {
    if (!Number(state.paymentAmount)) {
      global.showDialog(
        "Invalid Payment Amount",
        "Please enter a valid Payment Amount. Payment amount should be a number greater than 0"
      );
      return;
    }
    global.showConfDialog(
      "Are you sure?",
      <span>
        This action will add a payment of{" "}
        <span
          style={{
            color: "#007afb",
            fontWeight: "bold",
            margin: "0px 10px",
          }}
        >
          {formatCurrency(state.paymentAmount)}
        </span>{" "}
        to account number{" "}
        <span
          style={{
            color: "#007afb",
            fontWeight: "bold",
            margin: "0px 10px",
          }}
        >
          {state.account.account_number} - ({state.account.holder_name})
        </span>
      </span>,
      () => {
        handlePay();
      },
      ["Confirm", "Cancel"]
    );
  };

  const handlePay = async () => {
    if (!Number(state.paymentAmount)) {
      global.showAlert("Invalid Payment Amount", "", "warning");
      return;
    }
    if (!state.account) {
      global.showAlert("Account not found", "", "warning");
      return;
    }
    const payment = await createPaymentCall({
      account_id: state.account.id,
      amount: Number(state.paymentAmount),
      reference: state.reference,
    });
    if (payment) {
      global.showDialog(
        "Payment Success",
        `A payment of ${formatCurrency(payment.amount)} is successfully add to the account number ${
          payment.account.account_number
        } - (${payment.account.holder_name})`
      );
      setState({
        ...state,
        submitted: true,
        account: payment.account,
      });
    } else {
      global.showDialog(
        "Payment Failed",
        `An error has occurred in the server. Please try again later on contact system admin`
      );
    }
  };

  const printReceipt = async () => {
    const data = await getPaymentReceiptData(state.account.id);
    if (data) {
      paymentPrint(data);
    }
  };

  return (
    <DashboardLayout>
      <MobileNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Payments
                </MDTypography>
              </MDBox>
              {!state.account && (
                <MDBox pt={3} px={2}>
                  <Grid
                    container
                    alignItems={"center"}
                    justifyContent={"center"}
                    mb={2}
                    spacing={1}
                  >
                    <Grid item>
                      <MDInput
                        type="number"
                        label="Enter Account Number.."
                        value={state.accountNo}
                        onChange={(event) => {
                          setState({ ...state, accountNo: event.target.value });
                        }}
                        style={{
                          width: "250px",
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            getAccount();
                          }
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <MDButton
                        onClick={() => {
                          getAccount();
                        }}
                        variant="gradient"
                        color="dark"
                      >
                        Search
                      </MDButton>
                    </Grid>
                  </Grid>
                </MDBox>
              )}

              {state.noResult && (
                <MDBox mx={"auto"} my={3} width="fit-content">
                  <MDTypography>Account Not Found!</MDTypography>
                </MDBox>
              )}
              {state.account && (
                <MDBox pt={3} pb={3}>
                  <DefaultInfoCard
                    title={state.account.holder_name}
                    description={state.account.address}
                    icon="person"
                    value={<AccountBalance balance={state.account.current_balance} />}
                    noShadow
                  />
                  {state.confirmed && !state.submitted && (
                    <MDBox
                      mb={2}
                      mx={"auto"}
                      my={3}
                      width="fit-content"
                      display="flex"
                      flexDirection="column"
                    >
                      <MDInput
                        type="number"
                        label="Payment Amount"
                        value={state.paymentAmount}
                        onChange={(event) => {
                          setState({ ...state, paymentAmount: event.target.value });
                        }}
                        style={{
                          width: "250px",
                        }}
                      />
                      <MDBox height={10} />
                      <MDInput
                        type="string"
                        label="Payment Reference"
                        value={state.reference}
                        onChange={(event) => {
                          setState({ ...state, reference: event.target.value });
                        }}
                        style={{
                          width: "250px",
                        }}
                      />
                    </MDBox>
                  )}

                  {state.confirmed && state.submitted && (
                    <MDBox mx={"auto"} width="fit-content" color="green">
                      Payment Added Successfully!
                    </MDBox>
                  )}

                  {!state.submitted && (
                    <MDBox mx={"auto"} my={3} width="fit-content">
                      <MDButton
                        style={{
                          width: "120px",
                          margin: "2px",
                        }}
                        onClick={state.confirmed ? pay : confirm}
                        variant="gradient"
                        color="info"
                        disabled={state.confirmed ? state.paymentAmount <= 0 : false}
                      >
                        {state.confirmed ? "pay" : "confirm"}
                      </MDButton>
                      <MDButton
                        style={{
                          width: "120px",
                          margin: "2px",
                        }}
                        onClick={goBack}
                        variant="gradient"
                        color="error"
                      >
                        {"Cancel"}
                      </MDButton>
                    </MDBox>
                  )}

                  {state.confirmed && (
                    <MDBox mx={"auto"} mt={1} width="fit-content">
                      <MDButton
                        style={{
                          width: "244px",
                        }}
                        onClick={printReceipt}
                        variant="gradient"
                        color={state.submitted ? "success" : "light"}
                      >
                        print receipt
                      </MDButton>
                    </MDBox>
                  )}
                  {state.confirmed && state.submitted && (
                    <MDBox mx={"auto"} mt={1} width="fit-content">
                      <MDButton
                        style={{
                          width: "244px",
                        }}
                        onClick={goBack}
                        variant="gradient"
                        color={"dark"}
                      >
                        Go Back
                      </MDButton>
                    </MDBox>
                  )}
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}
